import {CardMarkDto} from "../../common";

/** The subcard's question on one line, for lists and dialog messages. */
export function subcardQuestionLine(question: string): string {
    return question.split('\n').map(line => line.trim()).filter(line => line !== '').join(' / ');
}

/** A short label of what is marked, e.g. "Card: add plurals · 2 subcards". */
export function markSummary(mark: CardMarkDto): string {
    const parts: string[] = [];
    if (mark.wholeCard) parts.push(mark.note !== '' ? `Card: ${mark.note}` : 'Card');
    if (mark.subcards.length > 0) {
        parts.push(mark.subcards.length === 1 ? '1 subcard' : `${mark.subcards.length} subcards`);
    }
    return parts.join(' · ');
}

/** The mark turned into Regenerate instructions: the card note, then one line per marked subcard. */
export function markInstructions(mark: CardMarkDto | undefined): string | undefined {
    if (mark === undefined) return undefined;
    const lines = mark.wholeCard && mark.note !== '' ? [mark.note] : [];
    for (const subcard of mark.subcards) {
        const note = subcard.note !== '' ? subcard.note : 'fix this subcard';
        lines.push(`Subcard "${subcardQuestionLine(subcard.question)}": ${note}`);
    }
    return lines.length > 0 ? lines.join('\n') : undefined;
}
